import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TimelineCard as Original } from 'components/molecules'
import { TimelineCardSettings, TimelineCardFloatingSettings } from './TimelineCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'

export const defaultProps = {
  image: '',
  image2: '',
}

export const timelineCardItemParams = (enabled, id, blockProps, children) => ({
  pk: blockProps.id,
  intro: getTextEditor(children?.[0], enabled),
  name: getTextEditor(children?.[1], enabled),
  description: getTextEditor(children?.[2], enabled),
  image: blockProps.image,
  image2: blockProps.image2,
})

export const dynamicProps = []

export const TimelineCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-timeline-card ${props.className}`}>
        <Original
          item={timelineCardItemParams(enabled, blockProps.id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TimelineCard.craft = withCraft({
  name: 'TimelineCard',
  defaultProps: defaultProps,
  settings: TimelineCardSettings,
  floatingSettings: TimelineCardFloatingSettings,
})
